import React, { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { dashboardRoutesArray } from "@/router/constant";
import NavigationLayout from "@/components/NavigationLayout";
import ConnectionsMenu from "@/components/DashConnections/Menu";
import { DetectMobileView } from "@/router/DetectMobileView";
import { Flex, Page, Space } from "@payping/web-components";

const MobileConnectionsWrapper = () => {
  const location = useLocation();

  const memoDashboardRoutesArray = useMemo(() => dashboardRoutesArray(), []);
  const currentUrlObj = memoDashboardRoutesArray.find((i) => i.url === location.pathname);

  const mainMenu = <ConnectionsMenu />;

  const subMenus = (
    <NavigationLayout
      menu={mainMenu}
      mobileBackNavigation={DashboardRoutes.connections.root.url}
      mobileTitle={currentUrlObj?.meta?.translation || ""}
    >
      <Page>
        <Space direction={"vertical"} className={"tw-w-full tw-gap-4 tw-font-medium lg:tw-gap-12"}>
          <Outlet />
        </Space>
      </Page>
    </NavigationLayout>
  );

  return location.pathname === DashboardRoutes.connections.root.url ? mainMenu : subMenus;
};

const DesktopConnectionsWrapper = () => {
  const Styles = {
    PagePadding: "!tw-pl-4 !tw-pr-8",
    FlexContentWrapper: "tw-w-full tw-gap-4 xl:tw-gap-12",
  };
  return (
    <NavigationLayout menu={<ConnectionsMenu />}>
      <Page className={Styles.PagePadding}>
        <Flex vertical className={Styles.FlexContentWrapper}>
          <Outlet />
        </Flex>
      </Page>
    </NavigationLayout>
  );
};

const ConnectionsRoot: React.FC = () => (
  <DetectMobileView mobile={<MobileConnectionsWrapper />} desktop={<DesktopConnectionsWrapper />} />
);
export default ConnectionsRoot;
